import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PhotoGallery = ({ photos = [] }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  if (!photos || photos?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="Image" size={24} className="text-primary" />
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">
            Photos de la propriété
          </h2>
        </div>
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Icon name="ImageOff" size={48} className="text-muted-foreground mb-4" />
          <p className="caption text-muted-foreground">
            Aucune photo disponible pour cette propriété
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <div className="flex items-center gap-3">
            <Icon name="Image" size={24} className="text-primary" />
            <h2 className="text-xl md:text-2xl font-semibold text-foreground">
              Photos de la propriété
            </h2>
          </div>
          <span className="caption text-muted-foreground">
            {photos?.length} {photos?.length === 1 ? 'photo' : 'photos'}
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {photos?.map((photo, index) => (
            <button
              key={index}
              onClick={() => setSelectedPhoto(photo)}
              className="relative aspect-[4/3] rounded-lg overflow-hidden group cursor-pointer"
            >
              <Image
                src={photo?.url}
                alt={photo?.alt}
                className="w-full h-full object-cover transition-transform group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                <Icon 
                  name="Maximize2" 
                  size={24} 
                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
                />
              </div>
            </button>
          ))}
        </div>
      </div>
      {selectedPhoto && (
        <div 
          className="fixed inset-0 bg-background/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedPhoto(null)}
        >
          <div className="relative max-w-6xl w-full max-h-[90vh]">
            <Button
              variant="ghost"
              size="icon"
              iconName="X"
              onClick={() => setSelectedPhoto(null)}
              className="absolute top-0 right-0 z-10"
            />
            <div className="rounded-xl overflow-hidden">
              <Image
                src={selectedPhoto?.url}
                alt={selectedPhoto?.alt}
                className="w-full h-full object-contain"
              />
            </div>
            {selectedPhoto?.caption && (
              <p className="text-center caption text-muted-foreground mt-4">
                {selectedPhoto?.caption}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoGallery;